module.exports = __webpack_public_path__ + "images/chart03Preview.png";